import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import type * as state from '../../../../../../../../../../state'

/**
 * Edits the comment an Unassigned Sponsored report keeps on one payroll entry.
 */
@ngCore.Component({
  imports: [
    ds.button.Component,
    ds.input.textArea.Component,
    ds.layout.widget.Component,
    ds.notice.Component,
    ds.overlay.centered.Component,
  ],
  selector: 'atn-space-unassigned-sponsored-comment-modal',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** Collection whose payroll entry the comment is left on. */
  public readonly collectionSg = ngCore.input.required<
    | state.space.full.unassignedSponsoredAccounts.Collection
    | state.space.full.unassignedSponsoredPeople.Collection
  >({ alias: 'collection' })

  /** @see {@link ents.core.display.Style} */
  public readonly DisplayStyle = ents.core.display.Style

  /** The payroll entry whose comment is being edited. */
  private readonly _editedEntitySg = ngCore.computed(() =>
    this.collectionSg()
      .plugins.currentEntityPlugin.feature.selectors.getEditedEntity()
      .asSignal(),
  )

  /** Draft comment displayed by the text area. */
  public readonly commentSg = ngCore.computed(
    (entity = this._editedEntitySg()) => entity?.comment ?? '',
  )

  /** Stores the edited comment on the draft entity. */
  public commentChangedHandler(comment: string | undefined): void {
    this.collectionSg()
      .plugins.editingPlugin.feature.actions.edit.from(
        'Space.UnassignedSponsored.CommentModal.Comment.Inputted',
      )
      .dispatch({
        edit: { input: { comment: comment ?? '' } },
      })
  }

  /** Saves the comment and closes the modal. */
  public saveClickHandler(): void {
    this.collectionSg()
      .plugins.editingPlugin.feature.actions.submit.from(
        'Space.UnassignedSponsored.CommentModal.Save.Clicked',
      )
      .dispatch({ current: true })
  }

  /** Discards the edit and closes the modal. */
  public cancelClickHandler(): void {
    this.collectionSg()
      .plugins.editingPlugin.feature.actions.discard.from(
        'Space.UnassignedSponsored.CommentModal.Cancel.Clicked',
      )
      .dispatch({ current: true })
  }
}
